export const parsePrice = (price: number, currency?: string, showAsInteger: boolean = false) => {
  return (price).toLocaleString('de-DE', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: showAsInteger ? 0 : undefined });
};
